<template>
    <b-container class="atmo-nested-section">
        <b-row>
            <b-col>
                <h3 class="grey-color font-weight-bold mb-3">Создание дополнительного соглашения о расторжении</h3>
            </b-col>
            <b-col md="auto">
                <b-button href="https://info.zakupschik.ru/201--rastorzhenie-dogovora-s-postavshikom" variant="custom-danger" class="font-weight-bold mt-1 mr-1" target="_blank">Инструкция по расторжению контракта</b-button>
            </b-col>
        </b-row>

        <b-overlay :show="isLoading" opacity="0.6" rounded spinner-variant="primary">
            <form-row-single-select label="Основание для расторжения контракта" v-model="terminationType" :v="$v.terminationType" :options="$globalDictionaries.fl44ContractTerminationTypes" labelField="title" />
        </b-overlay>
        <component v-if="terminationType" :is="createComponent" @cancel="onCancel" :pivc="pivc" :purchase="purchase" :terminationType="terminationType" @done="onSend" />
        <b-button v-if="!terminationType" variant="custom-outline-secondary" class="text-uppercase mt-1" @click="onCancel">Отмена</b-button>
    </b-container>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import Fl44ContractSupplementaryAgreementTerminationCreateAgreementOfPartiesBlock from '@/components/products/fl44/partials/fl44-contract-supplementary-agreement-termination-create-agreement-of-parties-block.vue';
import Fl44ContractSupplementaryAgreementTerminationCreateOtherBlock from '@/components/products/fl44/partials/fl44-contract-supplementary-agreement-termination-create-other-block.vue';

export default {
    name: 'fl44-contract-supplementary-agreement-termination-create',
    props: {
        purchase: {
            type: Object
        },
        pivc: {
            type: Object
        }
    },
    data() {
        return {
            isLoading: false,
            terminationType: null
        };
    },
    validations() {
        return {
            terminationType: {
                required
            }
        };
    },
    mounted() {
        // this.fillData();
    },
    methods: {
        onCancel() {
            this.$emit('cancel');
        },
        onSend() {
            this.$emit('done');
        },
        // async fillData() {
        //     this.isLoading = true;
        //     await this.$api.personal.fl44
        //         .getSupplementaryAgreementTerminationTemplateData(this.purchase.id)
        //         .then((response) => {
        //             this.form.deliverables = response.deliverables;
        //             this.contract_conclusion_date = response.contract_conclusion_date;
        //             this.price = response.price;
        //             this.priceLimit = response.max_price;
        //         })
        //         .catch(() => {
        //             this.$emit('cancel');
        //         })
        //         .finally(() => {
        //             this.isLoading = false;
        //         });
        // },
        // async createSupplementaryAgreement() {
        //     this.isLoading = true;
        //     await this.$api.personal.fl44
        //         .sendSupplementaryAgreementToSupplier(this.purchase.id, this.form)
        //         .then(() => {
        //             this.$emit('done');
        //         })
        //         .finally(() => {
        //             this.isLoading = false;
        //         });
        // }
    },
    computed: {
        createComponent() {
            switch (this.terminationType) {
                case 'agreement_of_parties':
                    return Fl44ContractSupplementaryAgreementTerminationCreateAgreementOfPartiesBlock;
                default:
                    return Fl44ContractSupplementaryAgreementTerminationCreateOtherBlock;
            }
        }
    }
};
</script>
